import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import classNames from 'classnames';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const partners = {
  cig: 'https://cig-poshta.in.ua/shop/marlboro/?utm_source=CDAsmsMRLB40',
  rozetka:
    'https://rozetka.com.ua/ua/sigareti/c4638591/producer=marlboro/?utm_source=PMUsmsMRLB40'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.headContainer}>
          <img
            className={styles.headBg}
            src={getImageFromS3('images/sms-mrl-40/head-bg.png')}
            alt="headBg"
          />
          <svg
            width="198"
            height="77"
            viewBox="0 0 198 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M100.396 0.00584618V1.29201H102.881V75.3865H100.876V76.7778L109.75 76.7545V75.1292C111.153 76.9065 113.661 76.7311 113.661 76.7311L113.626 76.7428L116.76 76.7311C120.946 76.7311 123.132 73.4806 123.132 69.435V43.2383C123.132 40.1399 121.834 37.7371 119.338 36.79C118.584 36.4626 117.736 36.2697 116.76 36.2697H113.626C113.322 36.258 111.06 36.2346 109.75 37.8832V36.258H109.739L109.785 0L100.396 0.0116924V0.00584618ZM84.4773 1.38554H87.0788V75.3397H84.4773V76.7778L96.5905 76.7662V75.3397H94.0942V0.0409232L84.4773 0.00584618V1.38554ZM23.8875 18.8715L17.0884 57.8128C17.0533 58.0935 16.9948 58.3916 16.761 58.3916C16.5856 58.3916 16.4804 58.1812 16.4102 57.731L9.57604 18.8715H0V20.1342H2.22739V75.3981H0.152001V76.6258H5.95141V75.3981H3.77078V36.4158C3.77078 35.4746 3.84094 35.3109 4.03971 35.3109C4.12155 35.2992 4.34371 35.2992 4.47817 36.4041L11.4877 76.6317H15.849L22.917 36.0943C23.0573 35.0361 23.1976 34.8315 23.3906 34.8549C23.4841 34.8549 23.7413 34.8666 23.7413 36.1995V75.3923H21.7712V76.6317H33.6155V75.3923H31.6454V20.1342H33.7207V18.8715H23.8933H23.8875ZM185.283 36.4509C181.535 36.4509 177.776 39.8066 177.776 43.9457V69.5286C177.776 73.6618 181.535 77 185.283 77H190.077C193.801 77 197.572 73.656 197.572 69.5286V43.9457C197.572 39.8008 193.801 36.4509 190.077 36.4509H185.283ZM136.888 36.4509C133.153 36.4509 129.405 39.8066 129.405 43.9457V69.5286C129.405 73.6618 133.153 77 136.888 77H141.694C145.429 77 149.177 73.656 149.177 69.5286V43.9457C149.177 39.8008 145.429 36.4509 141.694 36.4509H136.888ZM45.682 36.5211C41.4962 36.5211 38.8829 37.6026 38.6374 41.5312V50.1894H44.6239L44.6589 39.8183C44.6589 38.5322 45.8866 37.4974 47.582 37.4974C49.2774 37.4974 50.5987 38.6783 50.5987 39.9703V54.6851C49.3008 53.9076 47.5002 53.8491 47.5002 53.8491C44.1328 53.8491 42.8817 54.3694 42.5368 54.5799C40.5082 55.3925 38.3509 57.3159 38.3509 61.6713V71.1947C38.3509 71.1947 38.1171 76.7895 44.5362 76.7895H46.6349C48.6285 76.7895 49.8503 76.012 50.5928 75.1292V76.7895H59.5258V75.3514H57.4504V41.8762C57.4504 36.9537 54.1882 36.5269 49.827 36.5269H45.682V36.5211ZM153.515 37.8774H155.438L155.485 75.4683H153.258V76.9766H164.956V75.4683H162.401V39.4792C162.494 38.7017 163.237 38.1697 164.166 38.1697H164.921C165.827 38.1697 166.523 38.7017 166.914 39.4792C167.101 39.9645 167.195 40.6719 167.195 41.6482V50.7214H173.17V44.618C173.17 42.6011 173.275 40.7771 172.79 39.4792C171.802 37.702 170.089 36.5445 167.663 36.5445L165.85 36.5328V36.5445C165.85 36.5445 163.424 36.3808 162.079 38.1229V36.5328L153.515 36.5094V37.8774ZM62.5249 37.8774H64.4482L64.495 75.4683H62.2676V76.9766H73.9658V75.4683H71.4227V39.4792C71.5046 38.7017 72.2471 38.1697 73.1649 38.1697H73.9307C74.8486 38.1697 75.5209 38.7017 75.936 39.4792C76.0997 39.9645 76.2166 40.6719 76.2166 41.6482V50.7214H82.168V44.618C82.168 42.6011 82.2732 40.7771 81.7939 39.4792C80.8059 37.702 79.0812 36.5445 76.6551 36.5445L74.8544 36.5328V36.5445C74.8544 36.5445 72.44 36.3808 71.0837 38.1229V36.5328L62.519 36.5094V37.8774H62.5249ZM116.386 40.4205V72.5978C116.386 73.9775 115.281 75.0941 113.924 75.0941H112.159C110.791 75.0941 109.698 73.9775 109.698 72.5978L109.733 40.0405C109.92 38.8478 110.925 37.93 112.159 37.93H113.924C115.281 37.93 116.386 39.0583 116.386 40.4263V40.4205ZM50.5987 57.7895V71.6449L50.587 72.7732C50.5636 74.1412 49.406 75.2345 47.962 75.2345H47.3131C45.8633 75.2345 44.6882 74.1178 44.6882 72.7381V57.7953C44.6882 56.4156 45.8574 55.299 47.3131 55.299H47.962C49.4119 55.299 50.5987 56.4156 50.5987 57.7953V57.7895ZM190.726 39.9879V73.2526C190.726 74.6323 189.714 75.7489 188.475 75.7489H186.873C185.634 75.7489 184.622 74.6323 184.622 73.2526V39.9879C184.622 38.6082 185.634 37.4915 186.873 37.4915H188.475C189.714 37.4915 190.726 38.6082 190.726 39.9879ZM142.354 39.9879V73.2526C142.354 74.6323 141.331 75.7489 140.092 75.7489H138.49C137.251 75.7489 136.239 74.6323 136.239 73.2526V39.9879C136.239 38.6082 137.251 37.4915 138.49 37.4915H140.092C141.331 37.4915 142.354 38.6082 142.354 39.9879Z"
              fill="white"
            />
          </svg>
          <div className={styles.headTextContainer}>
            <p className={styles.headText}>
              Cкоро великі пачки
              <br />
              <span>Marlboro Gold 40</span> та <span>Marlboro Red 40</span>
            </p>
            <div className={styles.disappearTitle}>зникнуть з полиць ❌</div>
            <img
              className={styles.packsImage}
              src={getImageFromS3('images/sms-mrl-40/packs.png')}
              alt="packs"
            />
            <p className={styles.butText}>Але</p>
            <p className={styles.packsSubtitle}>
              в нас є продукт формату
              <br />
              <b>20 сигарет з незмінними</b>
              <br />
              характеристиками
            </p>
          </div>
        </div>
        <div className={styles.packsCharacteristicContainer}>
          <img
            className={styles.packsBg}
            src={getImageFromS3('images/sms-mrl-40/packs-bg.png')}
            alt="packsBg"
          />
          <div className={classNames(styles.packTitle, styles.goldPackTitle)}>
            <p>Marlboro Gold 20</p>
            <p>6 мг смол | 0.5 мг нікотину</p>
          </div>
          <div className={classNames(styles.packTitle, styles.redPackTitle)}>
            <p>Marlboro RED 20</p>
            <p>9 мг смол | 0.7 мг нікотину</p>
          </div>
          <div className={styles.characteristicTitle}>
            Незмінні характеристики <br />
            “Кінг Сайз” <b>Стандарт формат</b>
          </div>
          <div className={styles.filterContainer}>
            <img
              src={getImageFromS3('images/sms-mrl-40/block-bg.png')}
              alt="blockBg"
              className={styles.blockBg}
            />
            <img
              src={getImageFromS3('images/sms-mrl-40/filter.png')}
              alt="filter"
              className={styles.filter}
            />
            <p className={styles.filterTitle}>Firm filter</p>
            <p className={styles.filterDescription}>
              Ущільнений ацетатний фільтр, який краще тримає форму та менше
              розмокає
            </p>
          </div>
          <div className={styles.tobaccoContainer}>
            <img
              src={getImageFromS3('images/sms-mrl-40/block-bg.png')}
              alt="blockBg"
              className={styles.blockBg}
            />
            <img
              src={getImageFromS3('images/sms-mrl-40/tobacco.png')}
              alt="tobacco"
              className={styles.tobacco}
            />
            <p className={styles.tobaccoTitle}>Selected premium tobaccos</p>
            <p className={styles.tobaccoDescription}>
              Відбірна суміш тютюну від Мальборо
            </p>
          </div>
          <div className={styles.buyContainer}>
            <p className={styles.buyTitleText}>Де купити?</p>
            <p className={styles.buyDescriptionText}>
              <b>Marlboro Red 20</b> та <b>Marlboro Gold 20</b> можна знайти у
              роздрібних точках продажу в твоєму місті або на офіційних онлайн
              сервісах, зокрема:
            </p>
            <div className={styles.buttonContainer}>
              <button
                onClick={() => {
                  sendEvent('rozetka');
                  window.open(partners.rozetka, '_blank');
                }}
              >
                Rozetka
              </button>
              <button
                onClick={() => {
                  sendEvent('Cig-Poshta');
                  window.open(partners.cig, '_blank');
                }}
              >
                Cig-poshta
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br /> серйозні
        <br /> захворювання та
        <br /> залежність
        <br />
        Дана інформація про
        <br /> продукт надається
        <br /> відповідно
        <br />
        до статті 15 Закону
        <br /> України «Про захист
        <br /> прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні.
        <br />
        <a href="/unsubscribe?returnLink=25-sms-mrl-40">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
